// extracted by mini-css-extract-plugin
export default {"info-box":"AllergyListWrite_info-box__vsw-w","text-list-box":"AllergyListWrite_text-list-box__Wi+K5"};